const jobIds = (state = {}, action) => {
  switch (action.type) {
    case 'SET_QUERY_IDS':
      return {
        ...state,
        [action.executeId]: {
          ...state[action.executeId],
          queryIds: [...action.ids],
        },
      };
    case 'SET_REQUEST_INFO':
      return {
        [action.executeId]: {
          ...state[action.executeId],
          type: action.appType,
          events: action.events,
          isCSV: action.isCSV,
          executeId: action.executeId,
        },
        ...state,
      };
    case 'DELETE_QUERY_IDS':
      return Object.keys(state)
        .filter((key) => key !== action.executeId)
        .reduce((prev, key) => ({ ...prev, [key]: { ...state[key] } }), {});

    default:
      return state;
  }
};

export default jobIds;

export const getIdsByExecutedId = (state, executedId) => [...state[executedId].queryIds];

export const getExecuteIds = (state) => Object.keys(state);

export const getCSVExecuteData = (state) =>
  Object.values(state).filter(({ isCSV, queryIds }) => isCSV && !!queryIds?.length);
